import BaseServiceCrud from './BaseServiceCrud';

export default class StationsMapService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'map';
        this.getCriteriaOptions = this.getCriteriaOptions.bind(this);
    }

    getCriteria(criteria) {
        let stationTypeList = undefined;
        if (criteria.stationTypeList !== null && criteria.stationTypeList && criteria.stationTypeList.length) {
            stationTypeList = [];
            criteria.stationTypeList.forEach((element) => {
                stationTypeList.push(element.enumValue);
            });
        }
        let fuelList = undefined;
        if (criteria.fuelList !== null && criteria.fuelList && criteria.fuelList.length) {
            fuelList = [];
            criteria.fuelList.forEach((element) => {
                fuelList.push(element.productType);
            });
        }
        let serviceList = undefined;
        if (criteria.serviceList !== null && criteria.serviceList && criteria.serviceList.length) {
            serviceList = [];
            criteria.serviceList.forEach((element) => {
                serviceList.push(element.productType);
            });
        }
        return this.objToQueryString({
            station_type_list: stationTypeList,
            fuel_list: fuelList,
            service_list: serviceList,
        });
    }

    getChargingStationCriteria(criteria) {
        let portTypeList = undefined;
        if (criteria.portTypeList !== null && criteria.portTypeList && criteria.portTypeList.length) {
            portTypeList = [];
            criteria.portTypeList.forEach((element) => {
                portTypeList.push(element.enumValue);
            });
        }
        let chargingPowerList = undefined;
        if (criteria.chargingPowerList !== null && criteria.chargingPowerList && criteria.chargingPowerList.length) {
            chargingPowerList = [];
            criteria.chargingPowerList.forEach((element) => {
                chargingPowerList.push(element.enumValue);
            });
        }
        let capabilityList = undefined;
        if (criteria.capabilityList !== null && criteria.capabilityList && criteria.capabilityList.length) {
            capabilityList = [];
            criteria.capabilityList.forEach((element) => {
                capabilityList.push(element.enumValue);
            });
        }
        return this.objToQueryString({
            port_type_list: portTypeList,
            charging_power_list: chargingPowerList,
            capability_list: capabilityList,
        });
    }

    getCriteriaOptions(transFileObjectName, translate) {
        return this.fetch(`${this.domain}/${this.path}/getCriteriaOptions`, {
            method: 'GET',
        }).then((res) => {
            res?.fuelTypeOptions?.forEach((element) => {
                if (element.productType === 'UNKNOWN_PETROL') {
                    res?.fuelTypeOptions?.splice(res?.fuelTypeOptions?.indexOf(element), 1);
                }
                element.name = translate(`${transFileObjectName}.${element.name}`);
            });
            res?.gastronomyTypeOptions?.forEach((element) => {
                element.name = translate(`${transFileObjectName}.${element.name}`);
            });
            res?.serviceTypeOptions?.forEach((element) => {
                element.name = translate(`${transFileObjectName}.${element.name}`);
            });
            res?.stationTypeOptions?.forEach((element) => {
                element.name = translate(`${transFileObjectName}.${element.name}`);
            });
            return Promise.resolve(res);
        });
    }
    getCriteriaPowerOptions() {
        return this.fetch(`${this.domain}/${this.path}/charging/getCriteriaPowerOptions`, {
            method: 'GET',
        }).then((res) => {
 return Promise.resolve(res);
        });
    }

    getStationById(markerId) {
        return this.fetch(`${this.domain}/${this.path}/getStationById/${markerId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    geocode(address) {
        return this.fetch(`${this.domain}/${this.path}/geocode?address=${address}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getChargingStationList(criteria) {
        const queryString = this.getChargingStationCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/charging-station/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getChargingStationById(markerId) {
        return this.fetch(`${this.domain}/${this.path}/charging-station/getStationById/${markerId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
